import React from "react";
import LazyVideoNew from "../LazyVideo/LazyVideoNew";
import Link from "next/link";
import AddToCartButton from "@/components/common/AddToCartButton";

/**
 * React component representing the "Innovation Worth" section.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for the component, including the title and video container.
 * @param {Object} props.commonAssets - Common assets used in the component.
 * @returns {JSX.Element} React component.
 */

const InnovationWorth = ({ data, commonAssets, maticProduct }) => {
  return (
    <>
      <div className="w-full relative px-[80px] pb-[80px] hidden lg:block">
        <div className="aspect-w-1280 aspect-h-720">
          <div className="w-full flex flex-col items-center z-1 pt-14">
            <div className="flex flex-col justify-center items-center lg:max-w-[945px]">
              <h2 className={`px-50px lg:px-40px text-center`}>
                {data?.finallyAFloorCleaningTitle}
              </h2>
            </div>
            <Link
              href="/product"
              className="btn-primary eyebrow-bold transition-colors max-w-fit inline-flex rounded-full mt-[40px]"
              title={commonAssets?.reserveYourMaticCta}
            >
              Learn More
            </Link>
          </div>
          <LazyVideoNew
            videoImagePath={data.finallyAFloorCleaningVideoContainer}
            isMobile={false}
            customClasses={`h-full w-full object-cover object-center rounded-[16px]`}
            loop={false}
          />
        </div>
      </div>

      <div className="w-full relative px-[24px] pb-[40px] block lg:hidden">
        <div className="w-full flex flex-col items-center z-1">
          <div className="flex flex-col justify-center items-center">
            <h2 className={`lg:pb-40px text-center`}>
              {data?.finallyAFloorCleaningTitle}
            </h2>
          </div>
          <Link
            href="/product"
            className="btn-primary eyebrow-bold transition-colors max-w-fit inline-flex mt-[23px] "
            title="Learn More"
          >
            Learn More
          </Link>
        </div>
        <div className="aspect-w-327 aspect-h-327 mt-[48px]">
          <LazyVideoNew
            videoImagePath={data.finallyAFloorCleaningVideoContainer}
            isMobile={true}
            customClasses={`h-full w-full object-cover object-center rounded-8`}
          />
        </div>
      </div>
    </>
  );
};

export default InnovationWorth;
